export default __webpack_public_path__ + "static/media/4.4cfe1e7b.png";